import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ContatoService {
    url: string = environment.url + 'Contato.do';

    constructor(private httpClient: HttpClient) {
    }

    cadastrarContato(tipoContato, nome, email, telefone, empresa, pais, comoConheceu, assunto, mensagem) {
        let body = new HttpParams();
        body = body.set('tipoContato', tipoContato)
            .set('nome', nome)
            .set('email', email)
            .set('telefone', encodeURI(telefone))
            .set('empresa', empresa)
            .set('pais', pais)
            .set('comoConheceu', comoConheceu)
            .set('assunto', assunto)
            .set('mensagem', mensagem)
            .set('metodo', 'contatoForm');

        return this.httpClient.post(this.url, body);
    }

    cadastrarRevenda(nome, email , telefone, empresa, cargo, pais, mensagem) {
        let body = new HttpParams();
        body = body.set('nome', nome)
            .set('email', email)
            .set('telefone', encodeURI(telefone))
            .set('empresa', empresa)
            .set('cargo', cargo)
            .set('pais', pais)
            .set('mensagem', mensagem)
            .set('metodo', 'revendaForm');

        return this.httpClient.post(this.url, body);
    }
}
